import {Session,} from '@toolpad/core';
import {AppProvider} from '@toolpad/core/AppProvider';
import {DashboardLayout} from '@toolpad/core/DashboardLayout';
import {PageContainer} from '@toolpad/core/PageContainer';
import React from 'react';
import {useAuth} from '../auth/AppAuthProvider';
import {LicenseType} from '../model/license/license-type';
import {NAVIGATION} from '../navigation/navigationConfig';
import {CmsFeatureTemplatePage} from '../pages/cms/feature-template/CmsFeatureTemplatePage';
import {TranslationsPage} from '../pages/translations/TranslationsPage';
import {OrganizationDetailsPage} from '../pages/organization/details/OrganizationDetailsPage';
import {OrganizationUsersPage} from '../pages/organization/users/OrganizationUsersPage';
import {SupportPlanPage} from '../pages/support/plan/SupportPlanPage';
import {SupportSlotDefinitionPage} from '../pages/support/slots/SupportSlotDefinitionPage';
import {SupportPage} from '../pages/support/ticket/SupportPage';
import {CreditSupportPage} from '../pages/credit-support/CreditSupportPage';
import {StatusCallsPage} from '../pages/status-calls/StatusCallsPage';
import {useDemoRouter} from '../router/useDemoRouter';
import {demoTheme} from '../theme/theme';
import OrganizationListPage from '../pages/organization/list/OrganizationListPage';

export default function DashboardLayoutWrapper({ window }: { window?: () => Window }) {
  const router = useDemoRouter();
  const authState = useAuth();

  const renderPage = () => {
    if (router.pathname.startsWith('/organization-details/')) {
      const id = router.pathname.replace('/organization-details/', '');
      return <OrganizationDetailsPage organizationId={id} router={router}/>;
    }

    if (router.pathname.startsWith('/support-plan/')) {
      const id = router.pathname.replace('/support-plan/', '');
      return <SupportPlanPage organizationId={id}/>;
    }

    if (router.pathname.startsWith('/organization-users')) {
      const id = router.pathname.replace('/organization-users/', '');
      return <OrganizationUsersPage organizationId={id} />;
    }

    switch (router.pathname) {
      case '/organizations':
        return <OrganizationListPage router={router}/>;
      case '/support':
        return <SupportPage />
      case '/credit-support':
        return <CreditSupportPage />
      case '/status-calls':
        return <StatusCallsPage />
      case '/support-slots':
        return <SupportSlotDefinitionPage/>
      case '/translations':
        return <TranslationsPage />;
      case '/cms/cms-feature-template':
        return <CmsFeatureTemplatePage />
      default:
        return <OrganizationListPage router={router}/>;
    }
  };

  const [session, setSession] = React.useState<Session | null>({
    user: {
      name: 'SmartVendor Administrator',
      email: 'admin@smartvendor.eu',
    },
  });

  const authentication = React.useMemo(() => {
    return {
      signIn: () => {
        setSession({
          user: {
            name: 'SmartVendor Administrator',
            email: 'admin@smartvendor.eu',
          },
        });
      },
      signOut: () => {
        setSession(null);
        authState.logout()
      },
    };
  }, []);

  return (
    <AppProvider
      navigation={NAVIGATION}
      router={router}
      theme={demoTheme}
      session={session}
      authentication={authentication}
      branding={{
        title: 'SmartVendor',
        homeUrl: '/',
      }}
    >
      <DashboardLayout>
        <PageContainer
          sx={{
            maxWidth: '100% !important',
            width: '100%',
            padding: 0,
          }}
        >
          {renderPage()}
        </PageContainer>
      </DashboardLayout>
    </AppProvider>
  );
}
